const translations = {
    createFlightGroup: 'Create Flight Group',
    createFlightLog: 'Upload Flight Log'
};

export default translations;
